import { render, staticRenderFns } from "./custom-field.vue?vue&type=template&id=72c0cc04"
import script from "./custom-field.vue?vue&type=script&lang=js"
export * from "./custom-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports